import { createContext } from 'react';

export interface ActivitiesContextData {
  isActivitiesReadOnly: boolean;
  showEmployeeName: boolean;
}

const defaultContext = {
  isActivitiesReadOnly: false,
  showEmployeeName: false,
};

export const ActivitiesContext =
  createContext<ActivitiesContextData>(defaultContext);

export * from './provider';
export * from './useActivitiesContext';
